import React from "react";

const EventPartnersBase = ({ partnersBaseData = [] }) => {
    if (!partnersBaseData.length) return null;

    return (
        <section className="mb-16 pt-16 lg:pt-32 lg:mb-32">
            
            {partnersBaseData.map(({ partners_group: { group_status, tpb_items } }, groupIndex) => (
                <div className="container mx-auto mb-8 px-5" key={groupIndex}>
                    {/* Название */}
                    <h3 className="font-bold text-center text-2xl uppercase mb-3">{group_status}</h3>
                    {/* Лого */}
                    <div className="flex flex-col sm:flex-row justify-center items-center flex-wrap gap-6">
                        {tpb_items.map(({ acf: { p_url, p_thumbnail, p_logo_width } }, partnerIndex) => (
                            <a
                                key={`${groupIndex}-${partnerIndex}`}
                                href={p_url}
                                className="text-center block p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ ...(p_logo_width && { maxWidth: `${p_logo_width}px` }) }}
                            >
                                <img
                                    src={p_thumbnail}
                                    alt={group_status}
                                    className="inline-block object-contain"
                                />
                            </a>
                        ))}
                    </div>

                </div>
            ))}
        </section>
    );
};

export default EventPartnersBase;